import { AlertCircle } from "lucide-react";
import { Link } from "react-router";
import { buttonClassName } from "./button-variants";
import { catalogCopy } from "@client/locales/id/catalog";

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  return (
    <div role="alert" className="flex flex-col items-center gap-4 rounded-2xl border border-border-default bg-surface p-8 text-center">
      <AlertCircle className="size-6 text-danger" aria-hidden="true" />
      <p className="text-sm text-foreground-muted">{catalogCopy.loadError}</p>
      {onRetry && (
        <button type="button" onClick={onRetry} className={buttonClassName("secondary")}>
          {catalogCopy.retry}
        </button>
      )}
    </div>
  );
}

interface NotFoundStateProps {
  title: string;
  description: string;
  backHref: string;
  backLabel: string;
}

export function NotFoundState({ title, description, backHref, backLabel }: NotFoundStateProps) {
  return (
    <main className="mx-auto flex min-h-[60dvh] max-w-xl flex-col items-center justify-center gap-5 px-4 text-center">
      <p className="font-mono text-xs tracking-widest text-foreground-muted">404</p>
      <h1 className="text-gradient text-3xl font-semibold tracking-tight">{title}</h1>
      <p className="text-foreground-muted">{description}</p>
      <Link to={backHref} className={buttonClassName("secondary")}>
        {backLabel}
      </Link>
    </main>
  );
}

export function CardGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" aria-hidden="true">
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="h-80 animate-pulse rounded-2xl border border-border-default bg-surface" />
      ))}
    </div>
  );
}
